import { render, staticRenderFns } from "./CFormSummary_IRTC.vue?vue&type=template&id=2aa22094&scoped=true&"
import script from "./CFormSummary_IRTC.vue?vue&type=script&lang=js&"
export * from "./CFormSummary_IRTC.vue?vue&type=script&lang=js&"
import style0 from "./CFormSummary_IRTC.vue?vue&type=style&index=0&id=2aa22094&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa22094",
  null
  
)

export default component.exports